import { render, staticRenderFns } from "./ProductSendDialog.vue?vue&type=template&id=6d9a4cf4&scoped=true&"
import script from "./ProductSendDialog.vue?vue&type=script&lang=js&"
export * from "./ProductSendDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductSendDialog.vue?vue&type=style&index=0&id=6d9a4cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9a4cf4",
  null
  
)

export default component.exports